import React from 'react';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { ArrowLeftBlack, ArrowRightBlack } from 'assets/icons';
import moment from 'moment';
import { ServiceService } from 'services';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalCalendar extends React.Component<Props> {

	calendar: any;

	state = {
		currentYear: moment().format('YYYY'),
		currentMonth: moment().format('MMMM'),
		events: []
	}

	componentDidMount() {
		window.dispatchEvent(new Event('resize'));

		this.load();
	}

	load = async () => {
		const res: any = await ServiceService.admin.getHolidays({
			service_id: this.props.item?.id
		});
		this.setState({
			events: res.holidays.map((i: any) => {
				return {
					date: i.day
				}
			})
		});
	}

	save = async () => {
		await ServiceService.admin.setHolidays({
			dates: JSON.stringify(this.state.events),
			service_id: this.props.item?.id
		});
		this.props.onClose();
	}

	updateDate = () => {
		this.setState({
			currentYear: moment(this.calendar?.getApi().getDate()).format('YYYY'),
			currentMonth: moment(this.calendar?.getApi().getDate()).format('MMMM')
		});
	}

	setAllDays = (day: string) => {
		let date = moment(this.state.currentYear + '-' + this.state.currentMonth,'YYYY-MMMM').startOf('month');
		const last_date = moment(this.state.currentYear + '-' + this.state.currentMonth,'YYYY-MMMM').endOf('month');
		let dates: any = [];
		while(date < last_date) {
			if (moment(date).format('ddd') == (day + '.') && moment(date) >= moment()) {
				dates.push(date.format('YYYY-MM-DD'));
			}
			date = date.add(1,'day');
		}
		let events: any = [...this.state.events];
		const count_days = events.filter((i: any) => moment(i.date).format('ddd') == (day + '.') && moment(i.date).format('YYYY-MMMM') == (this.state.currentYear + '-' + this.state.currentMonth)).length;
		events = events.filter((i: any) => moment(i.date).format('ddd') != (day + '.') || moment(i.date).format('YYYY-MMMM') != (this.state.currentYear + '-' + this.state.currentMonth));
		if (count_days < dates.length) {
			dates.forEach((date: string) => {
				events.push({
					date
				});
			});
		}
		this.setState({
			events
		});
	}
	
	render() {
		return (
			<div id="modal-calendar-bookings">
				<h3>Días feriados / no laborables</h3>

				<p className="type">{ this.props.item?.name }</p>

				<div className="row">
					<div className="col-lg-6">
						<div className="container-arrow">
							<button className="btn btn-arrow" onClick={ () => {
								this.calendar.getApi().prevYear();
								this.updateDate();
							} }>
								<img src={ ArrowLeftBlack } />
							</button>
							<h4>{ this.state.currentYear }</h4>
							<button className="btn btn-arrow" onClick={ () => {
								this.calendar.getApi().nextYear();
								this.updateDate();
							} }>
								<img src={ ArrowRightBlack } />
							</button>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="container-arrow">
							<button className="btn btn-arrow" onClick={ () => {
								this.calendar.getApi().prev();
								this.updateDate();
							} }>
								<img src={ ArrowLeftBlack } />
							</button>
							<h4>{ this.state.currentMonth }</h4>
							<button className="btn btn-arrow" onClick={ () => {
								this.calendar.getApi().next();
								this.updateDate();
							} }>
								<img src={ ArrowRightBlack } />
							</button>
						</div>
					</div>
				</div>
				<FullCalendar
					ref={ ref => this.calendar = ref }
			        plugins={[ dayGridPlugin ]}
			        initialView="dayGridMonth"
			        locale="es"
			        dayHeaderContent={ (args: any) => {
			        	return (
			        		<button className="btn day-container" onClick={ () => this.setAllDays(args.text) }>
								<p>{ args.text.substring(0,2) }</p>
		        			</button>
			        	)
			        } }
			        events={ this.state.events }
		        	eventContent={(eventInfo) => {
		        		// @ts-ignore
		        		const date = moment(eventInfo.event.start).format('YYYY-MM-DD');

		        		return (
		        			<button disabled={ date < moment().format('YYYY-MM-DD') } className="btn event-container" onClick={ () => {
		        				let events: any = [...this.state.events];
		        				const index = events.findIndex((i: any) => i.date == date);
		        				if (index == -1) {
		        					events.push({
			        					date
			        				});
		        				}
		        				else {
		        					events.splice(index,1);
		        				}
		        				this.setState({
		        					events
		        				});
		        			} }>
		        				{/*
		        				// @ts-ignore */}
		        				<p>{ moment(eventInfo.event.start).format('D') }</p>
		        			</button>
		        		)
		        	}}

		        	dayCellContent={ (info) => {
		        		const date = moment(info.date).format('YYYY-MM-DD');

		        		return (
		        			<button disabled={ date < moment().format('YYYY-MM-DD') } className="btn day-container" onClick={ () => {
		        				let events: any = [...this.state.events];
		        				const index = events.findIndex((i: any) => i.date == date);
		        				if (index == -1) {
		        					events.push({
			        					date
			        				});
		        				}
		        				else {
		        					events.splice(index,1);
		        				}
		        				this.setState({
		        					events
		        				});
		        			} }>
								<p>{ moment(info.date).format('D') }</p>
		        			</button>
		        		)
		        	} }
			        headerToolbar={{
			        	left: '',
			        	center: '',
			        	right:  ''
			        }}
			    />
				<div className="row">
					<div className="col-6 text-center">
						<button className="btn btn-cancel" onClick={ () => this.props.onClose() }>
							Cerrar
						</button>
					</div>
					<div className="col-6 text-center">
						<button className="btn btn-save" onClick={ () => this.save() }>
							Guardar
						</button>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalCalendar;